import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDTRAINROUTE_SOURCE_ID = 'browardTrainRouteSource';

const source = {
  id: BROWARDTRAINROUTE_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'bmpo-smartmetro-09142026',
  data: 'SELECT * FROM `us-con-gcp-npr-0000424-011325.diamond.Broward_Transit_Routes` WHERE Route_Transportation_Type = "Train"',
  geoColumn: 'geom_weekday',
};

export default source;
